import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loader from '../../base/components/Loader/Loader';

// Because of draging and other complexity, survey builder is required to has separate route
export default props => {
  const {
    component: Component,
    location,
    isAuthenticationProcessing,
    isAdmin,
    accountManagement,
    setSelectedAccountManagementRecord,
    onLogout,
    path,
    isDevAdmin,
    ...rest
  } = props;

  useEffect(
    () => {
      if (props && isAuthenticationProcessing === null) {
        if (location && location.pathname && location.pathname !== '/') {
          // Pass requested url to redirect to after authentication/login
          props.onLoad(location.pathname);
        } else {
          props.onLoad();
        }
      }
    },
    [isAuthenticationProcessing]
  );

  // Authenticating and fetch client data
  if (rest && isAuthenticationProcessing === true) {
    return (
      <div style={style.mainLoadingContainer}>
        <Loader isProcessing />
      </div>
    );
  }

  // Not authenticated and authentication not in process
  if (rest && !rest.isAuthenticated && isAuthenticationProcessing === false) {
    return (
      <Redirect
        to={{
          pathname: '/auth/login',
          state: { from: location }
        }}
      />
    );
  }

  // Restrict access to Development Dashboard and Survey Inspector.
  // `path` is the route path (basename "/clients" is stripped by the router),
  // so match against the unprefixed paths.
  // Only enforce once authentication has finished and succeeded — otherwise
  // isDevAdmin is still undefined on first render and would redirect a real
  // dev admin before their credentials load.
  const devPaths = ['/development-dashboard', '/survey-history'];
  if (
    isAuthenticationProcessing === false &&
    rest.isAuthenticated &&
    !isDevAdmin &&
    devPaths.some(p => path.startsWith(p))
  ) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location }
        }}
      />
    );
  }

  const pageContent = (renderProps, webSocketUrl) => (
    <div>
      <div
        className="tooltip-container"
        style={{ position: 'absolute', zIndex: 9999999999999999 }}
      />
      <Component {...renderProps} webSocketUrl={webSocketUrl} />
    </div>
  );

  return (
    <Route
      {...rest}
      render={renderProps =>
        rest.isAuthenticated !== null
          ? pageContent(renderProps, props && props.webSocketUrl)
          : []
      }
    />
  );
};

const style = {
  mainLoadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  }
};
